import { render, staticRenderFns } from "./oneDetails.vue?vue&type=template&id=8e39a28c&scoped=true&"
import script from "./oneDetails.vue?vue&type=script&lang=js&"
export * from "./oneDetails.vue?vue&type=script&lang=js&"
import style0 from "./oneDetails.vue?vue&type=style&index=0&id=8e39a28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e39a28c",
  null
  
)

export default component.exports